import { render, staticRenderFns } from "./CompetitiveDataScreen.vue?vue&type=template&id=1b92d363"
import script from "./CompetitiveDataScreen.vue?vue&type=script&lang=js"
export * from "./CompetitiveDataScreen.vue?vue&type=script&lang=js"
import style0 from "./CompetitiveDataScreen.vue?vue&type=style&index=0&id=1b92d363&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports